<template lang="pug">
.container-informacoes-pessoais
  .header-informacoes-pessoais
    .label Informações Básicas
    .imagem
      .foto-perfil(@click="selecionarFoto")
        .icone-camera
          LucideIcon(name="Camera" :size="20")
        img(:src="fotoPerfil" alt="Foto do Desenvolvedor")
      input(
        ref="inputFoto"
        type="file"
        accept="image/*"
        style="display: none"
        @change="onFotoSelecionada"
      )
      .click-foto-label Clique na imagem para alterar
  .formulario
    el-form(class="form-custom-nexa" :model="form" ref="formRef" label-width="100px")
      el-form-item(label="Nome Completo")
        el-input(v-model="form.nome" placeholder="Seu nome completo")
      el-form-item(label="função / Título")
        el-input(v-model="form.funcao" placeholder="Ex: Front-End")
      el-form-item(label="Localização")
        el-input(v-model="form.localizacao" placeholder="Ex: Av. Paulista 123, SP")
      el-form-item(label="Biografia")
        el-input(v-model="form.message" resize="none" type="textarea" rows="4")
  .btn-salvar
    ButtonPadrao(iconLeft)
      LucideIcon(slot="icon-left" name="Save" :size="16")
      | Salvar Alterações
</template>

<script>
import ButtonPadrao from '@/components/ui/ButtonPadrao.vue';

export default {
  name: 'InformacoesPessoais',
  components: {
    ButtonPadrao
  },
  data() {
    return {
      fotoPerfil: require('@/assets/placeholder.svg'),
      form: {
        nome: '',
        funcao: '',
        localizacao: '',
        message: ''
      }
    }
  },
  methods: {
    selecionarFoto() {
      if (this.$refs.inputFoto) this.$refs.inputFoto.click()
    },
    onFotoSelecionada(event) {
      const file = event.target.files && event.target.files[0]
      if (file) {
        const reader = new FileReader()
        reader.onload = e => {
          this.fotoPerfil = e.target.result
        }
        reader.readAsDataURL(file)
      }
    }
  }
}
</script>

<style lang="scss">
.container-informacoes-pessoais{
  width: 100%;
  border: 1px solid $borderColor;
  box-sizing: border-box;
  border-radius: 8px;
  background: $corFundoPadraoDashboard;

  .header-informacoes-pessoais{
    padding: 24px;
    box-sizing: border-box;

    .label{
      font-size: 20px;
      font-weight: 700;
      color: $corVerdeClaro;
      margin-bottom: 24px;
    }
    .imagem{
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;

      .foto-perfil {
        width: 96px;
        height: 96px;
        border-radius: 50%;
        overflow: hidden;
        border: 2px solid $corVerdeClaro;
        box-sizing: border-box;
        cursor: pointer;
        position: relative;
        z-index: 0;

        .icone-camera {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 4;
          opacity: .3;
        }
        
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          position: absolute;
          top: 0;
          left: 0;
          z-index: 1;
        }

        &::after {
          content: "";
          position: absolute;
          top: 0; left: 0; right: 0; bottom: 0;
          background: rgba(0,0,0,0.45);
          opacity: 0;
          transition: opacity 0.2s;
          z-index: 3;
          border-radius: 50%;
          pointer-events: none;
        }
        
        &:hover{
          color: $corVerdeClaro;  
          &::after {
            opacity: 1;
          }

          .icone-camera{
            opacity: 1;
          }
        }
      }
      .click-foto-label{
        margin-top: 8px;
        color: $corValueInfoContato;
        font-size: 14px;
      }
    }
  }
  .formulario{
    padding: 0 24px 24px;
    box-sizing: border-box;

    
    .enviar-mensagem{
      width: 100%;
      margin-top: 20px;

      .botao{
        width: 100%;
      }
    }
  }
  .btn-salvar{
    padding: 16px 24px 24px;
    box-sizing: border-box;
    border-top: 1px solid $borderColor;
    display: flex;
    justify-content: flex-end;
  }

  @media (max-width: 500px) {
    .btn-salvar{
      justify-content: center;
    }
  }
}
</style>